import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";

export function ImageCell(props) {
  return (
    <td className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_image_contents`}>
        {props.image && (
          <Image
            src={props.image}
            alt={props.alt}
            style={{
              height: "auto",
              width: props.imageSize ? props.imageSize : "100%",
            }}
          />
        )}
        {props.caption && props.caption}
      </div>
    </td>
  );
}

ImageCell.propTypes = {
  /**
   * Image source to be displayed on the cell
   */
  image: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
  /**
   * caption
   */
  caption: PropTypes.string,
};
